"use client";

import Session from "@lib/session";
import { useParams, useSearchParams } from "next/navigation";
import { useEffect } from "react";

declare global {
  interface Window {
    siteId: string;
  }
}

export default function LogoutIfRequested() {
  const searchParams = useSearchParams();
  const params = useParams();
  const dest = searchParams.get("dest");
  
  useEffect(() => {
    if (dest === "8") {
      Session.clearSession();
      const siteId = window.siteId || params.siteId;
      const basePath = process.env.basePath || "";
      window.location.href = `${basePath}/${siteId}/user/login`;
    }
  }, [dest, params.siteId]);

  return null;
}